import React, { Fragment, useState } from 'react';
import axios from 'axios';

const Form = () => {


    const [datos, setDatos] = useState({
        name: '',
        entity: '',
        email: '',
        phone: '',
        message: ''
    })

    const handleInputChange = (event) => {

        setDatos({
            ...datos,
            [event.target.name]: event.target.value
        })
    }

    const enviarDatos = (event) => {
        event.preventDefault()
        document.querySelector("#loading").classList.remove("hidden");

        /* const url = 'http://localhost/cide/api_cide/?contactar=1'; */
        const url = 'https://cide.org.co/api_cide/?contactar=1';

        axios.post(url, datos)
            .then(response => {
                let data = response.data;
                console.log("data:", data);
            })

        setTimeout(() => {
            document.querySelector("#successMessage").classList.remove("hidden");
            document.getElementById("formulario").reset();
            document.querySelector("#loading").classList.add("hidden");
        }, 2000);


        setTimeout(() => {
            document.querySelector("#successMessage").classList.add("hidden");
        }, 6000);



    }

    return (
        <Fragment>

            <form onSubmit={enviarDatos} className="dark:text-white" id="formulario">

                <div className="flex flex-col text-left gap-y-8 lg:text-xl">

                    <h1 className="text-center font-bold text-xl lg:text-4xl">¿Cómo podemos ayudarte    ?</h1>

                    <p className="text-center">Déjanos tus datos y te contactaremos<br /> en el menor tiempo posible</p>

                    <input type="text" onChange={handleInputChange} name="name" placeholder="Nombre*" className="bg-transparent border-b border-gray-400 focus:outline-none" required />

                    <input type="text" onChange={handleInputChange} name="entity" placeholder="Entidad*" className="bg-transparent border-b border-gray-400 focus:outline-none" required />

                    <input type="email" onChange={handleInputChange} name="email" placeholder="E-mail*" className="bg-transparent border-b border-gray-400 focus:outline-none" required />

                    <input type="number" onChange={handleInputChange} name="phone" placeholder="Celular*" className="bg-transparent border-b border-gray-400 focus:outline-none" required />

                    <textarea onChange={handleInputChange} name="message" placeholder="Cuéntanos... ¿Cómo podemos servirte?" className="bg-transparent border-b border-gray-400 focus:outline-none" rows="3" />

                    <div className="flex justify-center">
                        <p className="text-center w-full 2xl:w-2/3 text-sm">
                            Al hacer clic en el botón “Contactarme” autorizas el registro y gestión de tus datos personales de acuerdo con nuestra <a href="https://www.politicadeprivacidad.co/politica/cide" target="_blank" rel="noreferrer" className="text-blue-cide underline hover:text-blue-500">política de tratamiento</a>. También autorizas que te contactemos mediante llamada, SMS, e-mail y/o chat
                        </p>
                    </div>

                    <div className="flex justify-center">
                        <button type="submit" className="px-10 py-4 bg-blue-cide hover:bg-blue-700 rounded-full font-semibold text-white flex items-center">

                            <svg aria-hidden="true" className="w-5 h-5 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600 hidden" id="loading" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                            </svg>


                            Contactarme</button>
                    </div>

                    <div className="justify-center text-center bg-green-200 rounded-full text-green-700 border border-green-500 p-2 hidden" id="successMessage">
                        <p>Gracias por contactarnos, pronto nos comunicaremos contigo</p>
                    </div>
                </div>
            </form>

        </Fragment>
    );
}

export default Form;